import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { CountryCodes } from 'context';
import { fetchCountriesRoutine } from 'actions/routines/countries';
import RoutableHead from 'components/head/RoutableHead';
import { EXTERNAL_V2, NOT_FOUND, ACTIVE_EXTERNAL_ROUTES } from 'constants/routes';
import { getJoinedPath } from 'helpers/routeHelpers';
import AllowAny from 'modules/app/AllowAny';
import SwitchOr404 from 'modules/app/SwitchOr404';
import { ExternalModals, ExternalSideSheets } from 'modules/external/global/containers/components';
import { partnershipPartnerCompanyBrandFromPartnershipRequestSelector } from 'queries/partnershipCompoundSelectors';
import { byCountrySelector } from 'selectors/countriesSelectors';
import { notFoundErrorSelector } from 'selectors/errorsSelectors';
import ExternalRouteWrapper from './ExternalRouteWrapper';
const ExternalContainerV2 = () => {
    const dispatch = useDispatch();
    const countryCodes = useSelector(byCountrySelector);
    const brand = useSelector(partnershipPartnerCompanyBrandFromPartnershipRequestSelector);
    const notFoundError = useSelector(notFoundErrorSelector);
    useEffect(() => {
        dispatch(fetchCountriesRoutine());
    }, [dispatch]);
    if (notFoundError) {
        return React.createElement(Redirect, { to: `/${NOT_FOUND}` });
    }
    return (React.createElement(CountryCodes.Provider, { value: countryCodes },
        React.createElement(RoutableHead, { noIndex: true, themeColor: brand?.primaryColor ?? '#fff' }),
        React.createElement(SwitchOr404, null,
            React.createElement(AllowAny, { component: ExternalRouteWrapper, path: ACTIVE_EXTERNAL_ROUTES.map((route) => getJoinedPath(EXTERNAL_V2, route)) }),
            React.createElement(AllowAny, { component: ExternalRouteWrapper, path: ACTIVE_EXTERNAL_ROUTES.map((route) => getJoinedPath(route)) })),
        React.createElement(AllowAny, { component: ExternalModals, path: "/" }),
        React.createElement(AllowAny, { component: ExternalSideSheets, path: "/" })));
};
export default ExternalContainerV2;
